export const HelveticaNeueLight = "'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', !default";